import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import FormButton from "../../components/FormButton"
import { useEffect, useState } from "react"
import { fetchData } from "../../api/Axios"

const FactionEdit = () => {
    const navigate = useNavigate()
    
    const [ faction, setFaction ] = useState(null)
    let { uuid } = useParams()

    const handleBack = async e => {
        e.preventDefault()
        navigate("/faction")
    }

    useEffect(() => {
        if(uuid == undefined) {
            return
        }

        console.log("Loading faction " + uuid + "...")
        fetchData("/api/factions/" + uuid, "Gefolge konnte nicht geladen werden.", faction => {
            setFaction(faction[0])
        })
    }, [uuid])

    return (
        <>
            <button className="btn btn-primary back" onClick={handleBack}>Zurück zur Übersicht</button>

            {
                faction == null ? <></> :
                <form className="form-horizontal">
                    <h3>{ faction.name }</h3>

                    <div className="card card-primary">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 col-sm-6">
                                    <FormButton label="Erstellt am" id="created" required="required" value={faction.creation_date_string} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                    <FormButton label="Rang" id="rank" required="required" value={faction.rank_name} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                    <FormButton label="Banner" id="banner" required="required" value={faction.banner_name} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                    <FormButton label="Beschreibung" id="description" required="required" value={faction.description} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                    <FormButton label="Orden" id="order_name" required="required" value={faction.order_name} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <FormButton label="Region ID" id="region" required="required" value={faction.region} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                    <FormButton label="Region Name" id="region_name" required="required" value={faction.region_name} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                    <FormButton label="Vasall von" id="lord_name" required="required" value={faction.lord_name} icon="fa-solid fa-network-wired" size="col-8" labelSize="col-3" />
                                    {faction.vassal_names.length == 0 ? "": <b>Vasallen</b>}
                                    {faction.vassal_names.map((vasall) => <li key={vasall}>{vasall}</li>)}
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 col-md-6 col-xl-3">
                                    <FormButton label="Geld" id="money" required="required" value={faction.money} icon="fa-solid fa-network-wired" size="col-5" labelSize="col-7" />
                                    <FormButton label="Einfluss" id="influence" required="required" value={faction.influence} icon="fa-solid fa-network-wired" size="col-5" labelSize="col-7" />
                                    <FormButton label="Steuern" id="taxes" required="required" value={faction.taxes} icon="fa-solid fa-network-wired" size="col-5" labelSize="col-7" />
                                    <FormButton label="Geld Steuer Warnungen" id="warns" required="required" value={faction.warns} icon="fa-solid fa-network-wired" size="col-5" labelSize="col-7" />
                                    <FormButton label="Pietät Steuer Warnungen" id="piety_warns" required="required" value={faction.piety_warns} icon="fa-solid fa-network-wired" size="col-5" labelSize="col-7" />
                                </div>
                                <div className="col-12 col-md-6 col-xl-3">
                                    {faction.members == null || faction.members.length == 0 ? "" : <b>Mitglieder</b>}
                                    {faction.members != null ? faction.members.map((member) => <li key={member}>{member}</li>) : <></>}
                                </div>
                                <div className="col-12 col-md-6 col-xl-3">
                                    {faction.builder_names.length == 0 ? "": <b>Baumeister</b>}
                                    {faction.builder_names.map((builder) => <li key={builder}>{builder}</li>)}
                                </div>
                                <div className="col-12 col-md-6 col-xl-3">
                                    {faction.upgrades.length == 0 ? "": <b>Verbesserungen</b>}
                                    {faction.upgrades.map((upgrade) => <li key={upgrade.name}>{upgrade.name} Level {upgrade.level}</li>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            }
        </>
    )
}
   
export default FactionEdit